import {Center, Heading, Link, SimpleGrid, VStack} from '@chakra-ui/react';
import {createFileRoute} from '@tanstack/react-router';
import {Gallery} from 'react-photoswipe-gallery';
import {Alert} from '../components/chakra-snippets/alert';
import Image from '../components/Image';
import {imageUrl} from '../utils/directusImage';
import {createServerFn} from '@tanstack/react-start';
import {desc, eq} from 'drizzle-orm';
import {db} from '../server/db.server';
import {event} from '../server/db/schema';
import {directusImages} from '../server/directusImage.server';
import {seo} from '../utils/seo';

const loader = createServerFn().handler(async () => {
  const data = await db
    .select({
      id: event.id,
      name: event.name,
      start: event.start,
      poster: event.poster,
    })
    .from(event)
    .where(eq(event.eventType, 'Kulturspektakel'))
    .orderBy(desc(event.start));

  const images = await directusImages(data.map((event) => event.poster));
  return data.map(({poster, ...data}) => ({
    ...data,
    poster: poster ? images[poster] : null,
  }));
});

export const Route = createFileRoute('/_main/plakate')({
  component: Plakate,
  loader: async () => await loader(),
  head: () =>
    seo({
      title: 'Plakate',
      description: 'Übersicht aller Kulturspektakel Plakate',
    }),
});

export default function Plakate() {
  const data = Route.useLoaderData();
  return (
    <VStack gap="10">
      <Heading as="h1" textAlign="center" size="3xl">
        Plakate
      </Heading>
      <Gallery options={{loop: false}} withCaption>
        <SimpleGrid columns={[2, 3, 4]} gap={5}>
          {data.map((event) =>
            event.poster ? (
              <Image
                key={event.id}
                original={imageUrl(event.poster.id, {width: 1600})}
                src={imageUrl(event.poster.id, {width: 200})}
                alt={event.name}
                originalHeight={event.poster.height}
                originalWidth={event.poster.width}
                caption={`Kulturspektakel ${event.start.getFullYear()} · Gestaltung: ${
                  event.poster?.copyright ?? 'unbekannt'
                }`}
              />
            ) : (
              <Center
                key={event.id}
                aspectRatio={1 / Math.SQRT2}
                borderRadius="xl"
                transform="rotate(-1deg)"
                borderWidth="2px"
                borderStyle="dashed"
                borderColor="offwhite.500"
                color="offwhite.600"
                fontFamily="heading"
                fontSize="3xl"
                title={`Kulturspektakel ${event.start.getFullYear()} · Plakat fehlt`}
              >
                {event.start.getFullYear()}
              </Center>
            ),
          )}
        </SimpleGrid>
        <Alert title="Fehlende Plakate?">
          Falls du ein Plakat hast, das hier noch fehlt, schick es uns gerne an{' '}
          <Link href="mailto:info@kulturspektakel.de?subject=Fehlendes Plakat">
            info@kulturspektakel.de
          </Link>
        </Alert>
      </Gallery>
    </VStack>
  );
}
